/*
 * Copyright 2022 Nightingale Team
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import React from 'react';
import Tooltip from '../../Fields/Tooltip';
import Legend from '../../Fields/Legend';
import GraphStyles from './GraphStyles';
import StandardOptions from '../../Fields/StandardOptions';
import Thresholds from '../../Fields/Thresholds';

export default function Timeseries() {
  return (
    <>
      <Tooltip />
      <Legend />
      <GraphStyles />
      <StandardOptions />
      <Thresholds />
    </>
  );
}
